import { MouseEvent } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import FormBlock from '@anwb/poncho/components/form-block';
import FormFieldCheckbox from '@anwb/poncho/components/form-field-checkbox';
import Panel from '@anwb/poncho/components/panel';
import Typography from '@anwb/poncho/components/typography';
import { setAgreedToTerms } from 'store/actions';
import { agreedToTermsSelector } from 'store/selectors';

const TERMS_URL =
	'https://merk.anwb.nl/m/4c0fbeb6204ff439/original/Wegenwacht-Service-incl-ANWB-lidmaatschap-Algemene-Voorwaarden-2025.pdf';

export const PrivacyStatement = () => {
	const dispatch = useDispatch();
	const privacyStatement = useSelector(agreedToTermsSelector);

	const handleClickOnConditions = (event: MouseEvent) => {
		event.preventDefault();
		window.open(TERMS_URL, '_blank', 'noopener noreferrer');
	};

	const handleCheckbox = (event: { valid: boolean }) => {
		if (event.valid !== privacyStatement) {
			dispatch(setAgreedToTerms(event.valid));
		}
	};

	return (
		<Panel id="privacy-statement" data-test="privacy-statement" hasOuterSpacing={false}>
			<Panel.Header title="Persoonsgegevens" />
			<Panel.Content>
				<Typography>
					De gegevens die je hebt ingevuld, worden door de ANWB verstrekt aan Leasemaatschappij
					Ayvens (voorheen bekend als LeasePlan), zodat we je aanvraag kunnen behandelen.
				</Typography>
				<>
					<Typography variant="component-title">ANWB-lidmaatschap en Wegenwacht</Typography>
					<Typography variant="body-text">
						Om een auto privé te kunnen rijden via ANWB Private Lease, moet je ANWB-lid zijn. Ben je
						nog geen ANWB-lid? Dan word je dat zodra de overeenkomst ingaat voor € 17,- per jaar.
						Het Wegenwacht Europa Standaard pakket krijg je er standaard bij of geld terug als je
						het al hebt.{' '}
						<Typography href="#" variant="link-text" onClick={handleClickOnConditions}>
							Bekijk de voorwaarden
						</Typography>
					</Typography>
				</>

				<FormBlock>
					<FormFieldCheckbox
						checked={privacyStatement}
						handlerChange={handleCheckbox}
						label="Ik ga akkoord met bovenstaande."
						name="privacy-statement-checkbox"
						reference="privacy-statement-checkbox"
						data-test="privacy-statement-checkbox"
						required
					/>
				</FormBlock>
			</Panel.Content>
		</Panel>
	);
};
